import { answerPaperLabel, paperOptions, type PaperId } from './papers'
import type { Subject } from './types'

export function PaperLabel({subject,topicId,ids}:{subject:Subject;topicId:string;ids:PaperId[]}) {
  return <span className={`paper-label ${subject==='Economics'?'paper-label-economics':''}`}>{answerPaperLabel({subject,topicId},ids)}</span>
}

export function PaperOptions({subject}:{subject:string}) {
  return <><option value="All">All papers</option>{(['Economics','Business'] as const).filter(s=>subject==='All'||s===subject).map(s=><optgroup key={s} label={s}>{paperOptions(s).map(p=><option key={p.id} value={p.id}>{p.label}</option>)}</optgroup>)}</>
}
